import { useMutation } from '@apollo/client'
import {
  ArchiveConversationDocument,
  ArchiveConversationMutationVariables,
} from 'generated/resources/graphql'

export const useArchiveConversation = () => {
  const [archiveConversationMutation, { loading }] = useMutation(ArchiveConversationDocument)

  return {
    loading,
    archiveConversation(variables: ArchiveConversationMutationVariables) {
      return archiveConversationMutation({
        variables,
      })
    },
  }
}
